import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

const BASE_URL =
  window._env_?.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "https://crclm-backend-dev.bravewave-24971d4f.eastus.azurecontainerapps.io/api";

function ExternalLoginPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/external/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("access_token", data.access_token);
        sessionStorage.setItem("user_role", data.user.role);
        sessionStorage.setItem("user_email", data.user.email);
        sessionStorage.setItem("user_name", data.user.full_name || data.user.username);
        navigate("/clm_home");
      } else {
        setError(data.error || "Login failed");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", width: "100%", height: "100%", overflow: "hidden" }}>
        <div style={{ position: "absolute", width: "500px", height: "500px", borderRadius: "50%", background: "rgba(255, 255, 255, 0.1)", top: "-250px", left: "-250px", animation: "float 6s ease-in-out infinite" }}></div>
        <div style={{ position: "absolute", width: "400px", height: "400px", borderRadius: "50%", background: "rgba(255, 255, 255, 0.1)", bottom: "-200px", right: "-200px", animation: "float 8s ease-in-out infinite reverse" }}></div>
        <div style={{ position: "absolute", width: "300px", height: "300px", borderRadius: "50%", background: "rgba(255, 255, 255, 0.08)", top: "50%", left: "50%", transform: "translate(-50%, -50%)", animation: "pulse 4s ease-in-out infinite" }}></div>
      </div>
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(20px); }
        }
        @keyframes pulse {
          0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.5; }
          50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.8; }
        }
      `}</style>
      <div style={{ background: "#ffffff", borderRadius: "16px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", maxWidth: "450px", width: "100%", padding: "40px", position: "relative", zIndex: 1 }}>
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <h1 style={{ fontSize: "32px", fontWeight: "700", color: "#ff6b35", margin: "0 0 10px 0" }}>Welcome Back</h1>
          <p style={{ color: "#6b7280", fontSize: "14px", margin: 0 }}>Login to access your contracts</p>
        </div>

        {error && <div style={{ background: "#fee2e2", color: "#dc2626", padding: "12px", borderRadius: "8px", marginBottom: "20px", fontSize: "14px", border: "1px solid #fecaca" }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", color: "#374151", fontSize: "14px", fontWeight: "600", marginBottom: "8px" }}>Username or Email</label>
            <input
              type="text"
              name="username"
              placeholder="Enter your username or email"
              value={formData.username}
              onChange={handleChange}
              required
              style={{ width: "100%", padding: "12px 16px", border: "2px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", transition: "all 0.3s", outline: "none", boxSizing: "border-box" }}
              onFocus={(e) => e.target.style.borderColor = "#ff6b35"}
              onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
            />
          </div>
          <div style={{ marginBottom: "24px" }}>
            <label style={{ display: "block", color: "#374151", fontSize: "14px", fontWeight: "600", marginBottom: "8px" }}>Password</label>
            <input
              type="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{ width: "100%", padding: "12px 16px", border: "2px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", transition: "all 0.3s", outline: "none", boxSizing: "border-box" }}
              onFocus={(e) => e.target.style.borderColor = "#ff6b35"}
              onBlur={(e) => e.target.style.borderColor = "#e5e7eb"}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{ width: "100%", padding: "14px", background: loading ? "#9ca3af" : "linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%)", color: "#ffffff", border: "none", borderRadius: "8px", fontSize: "16px", fontWeight: "600", cursor: loading ? "not-allowed" : "pointer", transition: "all 0.3s", boxShadow: "0 4px 12px rgba(255, 107, 53, 0.4)" }}
            onMouseEnter={(e) => !loading && (e.target.style.transform = "translateY(-2px)")}
            onMouseLeave={(e) => !loading && (e.target.style.transform = "translateY(0)")}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div style={{ marginTop: "24px", paddingTop: "24px", borderTop: "1px solid #e5e7eb" }}>
          <div style={{ textAlign: "center", fontSize: "14px", color: "#6b7280", marginBottom: "12px" }}>
            Don't have an account?{" "}
            <span
              onClick={() => navigate("/register")}
              style={{ color: "#ff6b35", cursor: "pointer", fontWeight: "600", textDecoration: "none" }}
              onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
              onMouseLeave={(e) => e.target.style.textDecoration = "none"}
            >
              Register here
            </span>
          </div>

          <div style={{ textAlign: "center", fontSize: "14px" }}>
            <span
              onClick={() => navigate("/login")}
              style={{ color: "#ff6b35", cursor: "pointer", fontWeight: "600", textDecoration: "none" }}
              onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
              onMouseLeave={(e) => e.target.style.textDecoration = "none"}
            >
              Login with Microsoft (CriticalRiver employees)
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExternalLoginPage;
